/**
 * Replaces spaces in a string with underscores.
 * Primarily used for <sl-option> values which can't contain spaces.
 * @param  {String} value - a string that may or may not include spaces
 * @return {String} - the string with spaces replaced by underscores
 * @public
 */
export default function underscoreize(value: string | undefined) {
  return value?.replace(/ /g, '_') || '';
}
